// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M12 4.53A6 6 0 0 1 20.24 4.76 6 6 0 0 1 20.48 13L12 21.49 3.52 13A6 6 0 0 1 12 4.54"/>';

/** Heart (actions). */
const icon: IconData = {
  id: "heart",
  name: "Heart",
  category: "actions",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path d="M12 4.53A6 6 0 0 1 20.24 4.76 6 6 0 0 1 20.48 13L12 21.49 3.52 13A6 6 0 0 1 12 4.54M18.83 6.18A4 4 0 0 0 13.34 6.03L12.01 7.23 10.67 6.03A4 4 0 0 0 4.98 11.64L12 18.65 19.02 11.62A4 4 0 0 0 18.83 6.17"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M17.27 3.14L18.34 3.48 19.34 4.02 20.24 4.76 20.98 5.66 21.53 6.66 21.86 7.73 22 8.83 21.93 9.94 21.65 11.03 21.17 12.06 20.48 13 12 21.49 3.52 13 2.83 12.06 2.36 11.03 2.08 9.95 2.02 8.84 2.15 7.74 2.49 6.67 3.03 5.68 3.78 4.78 4.68 4.04 5.68 3.5 6.74 3.16 7.84 3.03 8.95 3.1 10.03 3.37 11.06 3.85 12 4.53 12.94 3.84 13.97 3.35 15.06 3.08 16.17 3.01Z"/></g><path d="M12 4.53A6 6 0 0 1 20.24 4.76 6 6 0 0 1 20.48 13L12 21.49 3.52 13A6 6 0 0 1 12 4.54M18.83 6.18A4 4 0 0 0 13.34 6.03L12.01 7.23 10.67 6.03A4 4 0 0 0 4.98 11.64L12 18.65 19.02 11.62A4 4 0 0 0 18.83 6.17"/>',
    },
  },
  animation: () => import("../animations/heart.js"),
};

export default icon;
